import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { qk } from '@/lib/query-client'
import { useWorkspace } from '@/providers/workspace-provider'
import type { MemberWithProfile } from '@/types/domain'

export function useMembers() {
  const { workspaceId } = useWorkspace()
  return useQuery({
    queryKey: qk.members(workspaceId ?? 'none'),
    enabled: !!workspaceId,
    staleTime: 60_000,
    queryFn: async (): Promise<MemberWithProfile[]> => {
      const { data, error } = await supabase
        .from('workspace_members')
        .select('role,user_id,profile:profiles(id,full_name,avatar_url,email)')
        .eq('workspace_id', workspaceId!)
        .returns<MemberWithProfile[]>()
      if (error) throw error
      return data ?? []
    },
  })
}

/** Mapa id → profile, útil para resolver nomes em menções/histórico. */
export function useMemberMap() {
  const { data } = useMembers()
  const map = new Map((data ?? []).map((m) => [m.user_id, m.profile]))
  return map
}
